import React from "react";

import { InlineSection } from "../PatternSections";
import MatchRow from "./MatchRow";
import { TEXT } from "./editorText";
import { MATCH_SECTION } from "./matchModel";

const P = TEXT.previewScreen;

/** A section of matched rows (shared with the Learning Catalog's detail popups): its label with a count (lists) or a tag (the
 * fix kind), then the rows; `after` renders under the list (an empty note). */
export function MatchSection({ label, count, meta, after, children }) {
  return (
    <div className="le-field">
      <div className="le-mhead">
        <span className="le-label">{label}</span>
        {typeof count === "number" && <span className="le-count">{count}</span>}
        {meta && <span className="le-tag le-tag--muted">{meta}</span>}
      </div>
      <ol className="le-mrows">{children}</ol>
      {after}
    </div>
  );
}

/**
 * The Review screen's pattern while matching is on: the category inline, then symptoms, troubleshooting steps, the root
 * cause and the fix as one kind of row each (MatchRow), so the root cause and the fix read and work like the list rows.
 * `children` are further sections appended to the same stack.
 */
export default function MatchSections({ category, draft, fixKindLabel, match, onPick, onRetry, children }) {
  const row = (section, text, index = 0) => (
    <MatchRow key={`${section}-${index}`} section={section} index={index} text={text} match={match} onPick={onPick} onRetry={onRetry} />
  );
  return (
    <div className="le-fields">
      {category && <InlineSection label={P.category} value={category} />}
      <MatchSection label={P.symptoms} count={draft.symptoms.length}>
        {draft.symptoms.map((text, i) => row(MATCH_SECTION.SYMPTOMS, text, i))}
      </MatchSection>
      <MatchSection label={P.steps} count={draft.steps.length}>
        {draft.steps.map((text, i) => row(MATCH_SECTION.STEPS, text, i))}
      </MatchSection>
      <MatchSection label={P.rootCause}>{row(MATCH_SECTION.CAUSE, draft.rootCause)}</MatchSection>
      <MatchSection label={P.fix} meta={fixKindLabel}>{row(MATCH_SECTION.FIX, draft.fixText)}</MatchSection>
      {children}
    </div>
  );
}
